import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

// Custom label component for positioning labels outside of each segment without connecting lines
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent,
  index,
  name,
  value,
}) => {
  // Calculate the position of the label
  const RADIAN = Math.PI / 180;
  // Position outside the segment
  const radius = outerRadius * 1.2;
  // Calculate position based on the middle angle of the segment
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#333"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontWeight="bold"
      fontSize="12"
    >
      {`${value}%`}
    </text>
  );
};

const ToneAnalysisChart = ({ confident, neutral, hesitant }) => {
  // Data for the pie chart
  const data = [
    { name: 'Hesitant', value: hesitant, color: '#F2994A' },
    { name: 'Neutral', value: neutral, color: '#4F7CEB' },
    { name: 'Confident', value: confident, color: '#6FCF97' },
  ];

  return (
    <div className="h-64 mb-4 mt-4">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={80}
            dataKey="value"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ToneAnalysisChart;
